//models
import { ServiceCategory } from "../../../../models/Entities/ServiceCategory";
import { ErrorType } from "../../../../models/HttpError";

// stores
import * as ServiceCategoryStore from '../../../../redux/middleware/ServiceCategoryMiddleware';

//State
import { AppState } from "../../../../redux/reducers";


interface IProps {
  onSelectedServiceCategory: (categories: ServiceCategory[]) => void;
  ServiceCategoriesSelected: Array<string | ServiceCategory> | undefined;
  MultiselectEnable: boolean;
  noteText?: string;
  showLabel?: boolean;
  showManageButton?: boolean;
}

interface ConnectedProps {
  isLoading: boolean;
  isUpdating: boolean;
  isUpdatedSuccessfully: boolean;
  isLoadingSuccessfully: boolean;
  failOnUpdating: boolean;
  failOnLoading: boolean;
  error: ErrorType | undefined;
  ServiceCategories: ServiceCategory[];
}

interface DispatchProps {
  GetAllServiceCategories: typeof ServiceCategoryStore.actionCreators.GetAllServiceCategories;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => {
  return {
    isLoading: state.ServiceCategories?.isLoadingAll,
    isUpdating: state.ServiceCategories?.isLoadingAll,
    isUpdatedSuccessfully: state.ServiceCategories?.successLoadingAll,
    isLoadingSuccessfully: state.ServiceCategories?.successLoadingAll,
    failOnUpdating: state.ServiceCategories?.failOnLoadingAll,
    failOnLoading: state.ServiceCategories?.failOnLoadingAll,
    error: state.ServiceCategories?.error,
    ServiceCategories: state.ServiceCategories?.list || [],
  }
};

export const mapDispatchToProps = {
    ...ServiceCategoryStore.actionCreators
};

export default {
  mapStateToProps,
  mapDispatchToProps,
  Props: {} as Props
};
